<template>
  <span class="px-3 text-uppercase text-secondary text-xxs font-weight-bolder">
    {{ props.text }}
  </span>
</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    default: null,
  },
});
</script>
